import { render, staticRenderFns } from "./send-salary.vue?vue&type=template&id=29fc51e5"
import script from "./send-salary.vue?vue&type=script&lang=js"
export * from "./send-salary.vue?vue&type=script&lang=js"
import style0 from "./send-salary.vue?vue&type=style&index=0&id=29fc51e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports